/**
 * FollowUpQuestions - Displays suggested follow-up questions below assistant messages
 */

import { useTranslation } from '@/i18n'

interface FollowUpQuestionsProps {
  questions: string[]
  onQuestionClick: (question: string) => void
  isStreaming?: boolean
}

export function FollowUpQuestions({
  questions,
  onQuestionClick,
  isStreaming,
}: FollowUpQuestionsProps) {
  const { t } = useTranslation()
  // Don't show during streaming or if no questions available
  if (isStreaming || !questions || questions.length === 0) {
    return null
  }

  return (
    <div className="mt-4">
      <p className="text-sm text-gray-700 dark:text-gray-300 font-normal mb-3">
        {t('chatv2:messages.suggested_follow_ups', { defaultValue: 'Suggested follow-up questions' })}
      </p>
      <div className="flex flex-wrap gap-2">
        {questions.map((question, index) => (
          <button
            key={index}
            onClick={() => onQuestionClick(question)}
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-white dark:bg-dark-card hover:bg-gray-50 dark:hover:bg-dark-muted border border-gray-200 dark:border-dark-border rounded-full text-sm text-gray-700 dark:text-gray-300 transition-colors shadow-sm"
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  )
}
